var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('div',[_c('v-btn',{attrs:{"color":"primary darken-1","to":_vm.toContract,"block":"","elevation":"0","id":"dashboard-contractclaim"}},[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.buttons.submit_contract'))+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }